/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { RoleDto } from '../models/role-dto';


/**
 * Fonctions de gestion des rôles
 */
@Injectable({
  providedIn: 'root',
})
export class RolesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation roleGetList
   */
  static readonly RoleGetListPath = '/api/roles/list';

  /**
   * Renvoie la liste des rôles.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `roleGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  roleGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<RoleDto>>> {

    const rb = new RequestBuilder(this.rootUrl, RolesService.RoleGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<RoleDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des rôles.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `roleGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  roleGetList(params?: {
  }): Observable<Array<RoleDto>> {

    return this.roleGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<RoleDto>>) => r.body as Array<RoleDto>)
    );
  }

  /**
   * Path part for operation roleLoadList
   */
  static readonly RoleLoadListPath = '/api/roles/load-list';

  /**
   * Renvoie la liste des rôles (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `roleLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  roleLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, RolesService.RoleLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des rôles (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `roleLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  roleLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.roleLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation roleGet
   */
  static readonly RoleGetPath = '/api/roles/{id}';

  /**
   * Renvoie le rôle spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `roleGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  roleGet$Response(params: {

    /**
     * Identifiant du rôle
     */
    id: number;
  }): Observable<StrictHttpResponse<RoleDto>> {

    const rb = new RequestBuilder(this.rootUrl, RolesService.RoleGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RoleDto>;
      })
    );
  }

  /**
   * Renvoie le rôle spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `roleGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  roleGet(params: {

    /**
     * Identifiant du rôle
     */
    id: number;
  }): Observable<RoleDto> {

    return this.roleGet$Response(params).pipe(
      map((r: StrictHttpResponse<RoleDto>) => r.body as RoleDto)
    );
  }

  /**
   * Path part for operation rolePut
   */
  static readonly RolePutPath = '/api/roles/{id}';

  /**
   * Met à jour le rôle spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolePut$Response(params: {

    /**
     * Identifiant du rôle à mettre à jour
     */
    id: number;

    /**
     * Rôle
     */
    body: RoleDto
  }): Observable<StrictHttpResponse<RoleDto>> {

    const rb = new RequestBuilder(this.rootUrl, RolesService.RolePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RoleDto>;
      })
    );
  }

  /**
   * Met à jour le rôle spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rolePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolePut(params: {

    /**
     * Identifiant du rôle à mettre à jour
     */
    id: number;

    /**
     * Rôle
     */
    body: RoleDto
  }): Observable<RoleDto> {

    return this.rolePut$Response(params).pipe(
      map((r: StrictHttpResponse<RoleDto>) => r.body as RoleDto)
    );
  }

  /**
   * Path part for operation roleDelete
   */
  static readonly RoleDeletePath = '/api/roles/{id}';

  /**
   * Supprime le rôle spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `roleDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  roleDelete$Response(params: {

    /**
     * Identifiant du rôle à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, RolesService.RoleDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le rôle spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `roleDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  roleDelete(params: {

    /**
     * Identifiant du rôle à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.roleDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation rolePost
   */
  static readonly RolePostPath = '/api/roles';

  /**
   * Crée le rôle spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolePost$Response(params: {

    /**
     * Rôle
     */
    body: RoleDto
  }): Observable<StrictHttpResponse<RoleDto>> {

    const rb = new RequestBuilder(this.rootUrl, RolesService.RolePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RoleDto>;
      })
    );
  }

  /**
   * Crée le rôle spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rolePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolePost(params: {

    /**
     * Rôle
     */
    body: RoleDto
  }): Observable<RoleDto> {

    return this.rolePost$Response(params).pipe(
      map((r: StrictHttpResponse<RoleDto>) => r.body as RoleDto)
    );
  }

  /**
   * Path part for operation rolePutDetail
   */
  static readonly RolePutDetailPath = '/api/roles/{id}/detail';

  /**
   * Met à jour le rôle spécifié (détail).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rolePutDetail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolePutDetail$Response(params: {

    /**
     * Identifiant du rôle à mettre à jour
     */
    id: number;

    /**
     * Rôle
     */
    body: RoleDto
  }): Observable<StrictHttpResponse<RoleDto>> {

    const rb = new RequestBuilder(this.rootUrl, RolesService.RolePutDetailPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RoleDto>;
      })
    );
  }

  /**
   * Met à jour le rôle spécifié (détail).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rolePutDetail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rolePutDetail(params: {

    /**
     * Identifiant du rôle à mettre à jour
     */
    id: number;

    /**
     * Rôle
     */
    body: RoleDto
  }): Observable<RoleDto> {

    return this.rolePutDetail$Response(params).pipe(
      map((r: StrictHttpResponse<RoleDto>) => r.body as RoleDto)
    );
  }

  /**
   * Path part for operation roleGetRolePermissions
   */
  static readonly RoleGetRolePermissionsPath = '/api/roles/permissions';

  /**
   * Récupération des permissions du rôle spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `roleGetRolePermissions()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  roleGetRolePermissions$Response(params: {

    /**
     * Rôle
     */
    body: RoleDto
  }): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, RolesService.RoleGetRolePermissionsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * Récupération des permissions du rôle spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `roleGetRolePermissions$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  roleGetRolePermissions(params: {

    /**
     * Rôle
     */
    body: RoleDto
  }): Observable<Array<string>> {

    return this.roleGetRolePermissions$Response(params).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

}
